import React from 'react';
import { getCountryName } from '../helpers/countries';
import { useMediaQuery } from '../helpers/useMediaQuery';
import ReactCountryFlag from 'react-country-flag';

const CountryField = ({
	code,
	useShortFormOnMobile,
	truncate = true,
	title,
}) => {
	const isPageWide = useMediaQuery('(min-width: 1200px)');
	const isMediumWide = useMediaQuery('(min-width: 420px)');
	const countryFullName = getCountryName(code);
	const countryCode = code?.toUpperCase();
	const countryName = countryFullName;
	// const countryName = isPageWide || !useShortFormOnMobile ? countryFullName : countryCode;
	const sizeK = isMediumWide ? 1 : 0.7;
	const flagSize = {
		width:1.8 * sizeK,
		height:1.35 * sizeK,
	}
	const getMaxWidth = () => {
		if(isPageWide) return 'initial';
		if(isMediumWide) return '240px';
		return '200px';
	}
	return (
		<div
			className="country-field"
			style={{
				maxWidth: truncate ? '200px' : getMaxWidth(),
				// maxWidth: truncate ? '200px' : 'initial',
				width: '100%',
			}}
			title={title}
		>
			{code && (
				<ReactCountryFlag
					className="country-field__flag"
					title={countryFullName}
					countryCode={code.toUpperCase()}
					svg
					style={{
						width: flagSize.width + 'em',
						height: flagSize.height + 'em',
					}}
				/>
			)}
			<span className="truncate">{countryName}</span>
		</div>
	);
};
export default CountryField;
